import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { withStore } from "../store";
import { Service } from "../ApiService";
import Loader from "../Loader";
import DatePicker from "../DatePicker";
import SaveToExcelSVG from "../../svg/SaveToExcelSVG";
import { getFirstDayOfMonth, getLastDayOfMonth } from "../dateFunctions";
import InputWithClearButton from "../InputWithClearButton";
import MultiDropDown from "../MultiDropDown/MultiDropDown";

const TableHeader = ({ name }) => {
  return <strong style={{ color: "#00008B" }}>{name}</strong>;
};

const columns = [
  { Header: "First", accessor: "firstName" },
  { Header: "Last", accessor: "lastName" },
  { Header: "Chapter", accessor: "chapter" },
  { Header: "Email", accessor: "email" },
  { Header: "Phone", accessor: "phone" },
  { Header: "Gender", accessor: "gender" },
  { Header: "Race/Ethnicity", accessor: "ethnicity" },
  { Header: "Date of Birth", accessor: "dob" },
  { Header: "Address", accessor: "address" },
  { Header: "City", accessor: "city" },
  { Header: "State", accessor: "state" },
  { Header: "Zip Code", accessor: "zip" },
];

class DemographicReports extends Component {
  constructor(props) {
    super(props);
    this.chaptersDropDownRef = null;
    this.ethnicityDropDownRef = null;
    this.genderDropDownRef = null;
    this.eventDropDownRef = null;
    this.participantDropDownRef = null;
    this.disabilityDropDownRef = null;
    this.stateDropDownRef = null;
    props.store.refreshUserInfo();
    this.state = {
      data: [],
      columns: columns.map((col) => {
        return {
          Header: <TableHeader name={col.Header} />,
          accessor: col.accessor,
        };
      }),
      loading: false,
      expanded: true,
      filters: {
        FirstName: "",
        LastName: "",
        Chapter: [],
        Phone: "",
        Email: "",
        Gender: [],
        Ethnicity: [],
        dateOfBirthStart: null,
        dateOfBirthEnd: null,
        Address: "",
        City: "",
        State: [],
        ZipCode: "",
        eventTitle: [],
        eventDateStart: null,
        eventDateEnd: null,
        disabilityType: [],
        participantType: [],
        DOBRange: {},
      },
    };
  }

  reformattedFilters() {
    var constructedDOBRange = { StartDate: null, EndDate: null };
    var constructedEventsDateRange = { StartDate: null, EndDate: null };
    if (this.state.filters.dateOfBirthStart) {
      constructedDOBRange.StartDate = new Date(
        this.state.filters.dateOfBirthStart,
      );
    }
    if (this.state.filters.dateOfBirthEnd) {
      constructedDOBRange.EndDate = new Date(this.state.filters.dateOfBirthEnd);
    }
    if (this.state.filters.eventDateStart) {
      constructedEventsDateRange.StartDate = new Date(
        this.state.filters.eventDateStart,
      );
    }
    if (this.state.filters.eventDateEnd) {
      constructedEventsDateRange.EndDate = new Date(
        this.state.filters.eventDateEnd,
      );
    }

    return {
      ...this.state.filters,
      Gender: this.storeDBGenderValue(this.state.filters.Gender),
      participantType: this.storeDBParticipantTypeValue(
        this.state.filters.participantType,
      ),
      DOBRange: constructedDOBRange,
      EventsDateRange: constructedEventsDateRange,
    };
  }

  downloadExcel() {
    this.setState({ loading: true });
    var reportFilters = this.reformattedFilters();
    Service.downloadWithPost(
      "/api/Reports/DynamicDemographicsToExcel",
      reportFilters,
    ).then((blob) => {
      Service.throwBlob(blob, "DynamicDemographics.xlsx");
      this.setState({ loading: false });
    });
  }

  runReport() {
    this.setState({ loading: true });
    var reportFilters = this.reformattedFilters();
    Service.runDynamicDemographicsReport(reportFilters)
      .then((data) => {
        var dataTreated = [];
        data.forEach((d) => {
          var constructedDate = new Date(d["dob"]).toLocaleDateString();
          dataTreated.push({
            ...d,
            dob: constructedDate,
          });
        });
        this.setState({ loading: false });
        this.setState({ data: dataTreated });
      })
      .catch((er) => {
        console.log(er);
        this.setState({
          loading: false,
        });
      });
  }

  storeDBGenderValue(value) {
    var ret = [];
    value.forEach((val) => {
      if (val === "Male") {
        ret.push("M");
      } else if (val === "Female") {
        ret.push("F");
      } else if (val === "Other") {
        ret.push("O");
      } else {
        ret.push(val);
      }
    });
    return ret;
  }
  storeDBParticipantTypeValue(value) {
    var ret = [];
    value.forEach((val) => {
      if (val == "Veteran") {
        ret.push(53);
      } else if (val == "Civilian") {
        ret.push(54);
      } else if (val == "Veteran Family/Caregiver") {
        ret.push(55);
      } else {
        ret.push(0);
      }
    });
    return ret;
  }

  stateNameAndAbbrRender(element, textProperty) {
    return (
      <span className="text-transform-none">
        {element.name + ", " + element.abbreviation}
      </span>
    );
  }

  checkIfElementMeetsCriteria = (el, filterList, params) => {
    let checkParam = (param, elFilter) => {
      return el[param].toLowerCase().includes(elFilter);
    };
    let allParamsWereFound = true;
    filterList.forEach((elFilter) => {
      if (!params.find((param) => checkParam(param, elFilter))) {
        allParamsWereFound = false;
      }
    });
    return allParamsWereFound;
  };
  onContactInputValueChange(param, newValue) {
    let member = this.state.member;
    member.emergencyContact[param] = newValue;
    this.setState({ member: member });
  }

  searchValueIntoArray(filter) {
    /* remove all " " at the beginning and double ' ' inside the filter expression if they are there */
    filter = filter.replace(/\,+/g, " ");
    filter = filter.toLowerCase().replace(/\s+/g, " ");
    /* return an array of filters or empty string*/
    if (filter !== "") {
      return filter.split(" ");
    } else return "";
  }

  filterList = (list, filter, params) => {
    let filterList = this.searchValueIntoArray(filter);
    if (filterList === "") {
      return list;
    } else {
      let newList = [];
      list.forEach((element) => {
        if (this.checkIfElementMeetsCriteria(element, filterList, params)) {
          newList.push(element);
        }
      });
      return newList;
    }
  };

  performIfValid(callback) {
    if (this.props.store.isFormValid(this.validators, this.state.member)) {
      callback();
    } else {
      this.setState({ showError: true });
    }
  }

  render() {
    const chapterOptions = ["Chapter 1", "Chapter 2", "Chapter 3"];
    const genderList = [
      { group: "Male" },
      { group: "Female" },
      { group: "Other" },
    ];
    const ethnicityList = [
      { group: "American Indian or Alaska Native" },
      { group: "Asian" },
      { group: "African American or Black" },
      { group: "Hispanic or Latino" },
      { group: "Native Hawaiian or Other Pacific Islander" },
      { group: "White" },
      { group: "Prefer not to say" },
      { group: "Unknown" },
    ];

    const stateOptions = ["Maryland", "Alaska", "Georgia"];
    const eventList = [
      { event: "Flat Water" },
      { event: "River" },
      { event: "Pool" },
      { event: "Surf" },
      { event: "Kayak Polo" },
      { event: "Family Day" },
    ];
    const disabilityList = [
      { name: "Substance Abuse" },
      { name: "SCI - Paralysis Waist Down" },
      { name: "TBI" },
      { name: "Leg Right AK" },
      { name: "Leg Left AK" },
      { name: "Leg Right BK" },
      { name: "Leg Left BK" },
    ];
    const participantList = [
      { type: "Veteran" },
      { type: "Civilian" },
      { type: "Veteran Family/Caregiver" },
    ];

    const stateList = [
      { name: "Alabama", abbreviation: "AL" },
      { name: "Alaska", abbreviation: "AK" },
      { name: "Arizona", abbreviation: "AZ" },
      { name: "Arkansas", abbreviation: "AR" },
      { name: "California", abbreviation: "CA" },
      { name: "Colorado", abbreviation: "CO" },
      { name: "Connecticut", abbreviation: "CT" },
      { name: "Delaware", abbreviation: "DE" },
      { name: "Florida", abbreviation: "FL" },
      { name: "Georgia", abbreviation: "GA" },
      { name: "Hawaii", abbreviation: "HI" },
      { name: "Idaho", abbreviation: "ID" },
      { name: "Illinois", abbreviation: "IL" },
      { name: "Indiana", abbreviation: "IN" },
      { name: "Iowa", abbreviation: "IA" },
      { name: "Kansas", abbreviation: "KS" },
      { name: "Kentucky", abbreviation: "KY" },
      { name: "Louisiana", abbreviation: "LA" },
      { name: "Maine", abbreviation: "ME" },
      { name: "Maryland", abbreviation: "MD" },
      { name: "Massachusetts", abbreviation: "MA" },
      { name: "Michigan", abbreviation: "MI" },
      { name: "Minnesota", abbreviation: "MN" },
      { name: "Mississippi", abbreviation: "MS" },
      { name: "Missouri", abbreviation: "MO" },
      { name: "Montana", abbreviation: "MT" },
      { name: "Nebraska", abbreviation: "NE" },
      { name: "Nevada", abbreviation: "NV" },
      { name: "New Hampshire", abbreviation: "NH" },
      { name: "New Jersey", abbreviation: "NJ" },
      { name: "New Mexico", abbreviation: "NM" },
      { name: "New York", abbreviation: "NY" },
      { name: "North Carolina", abbreviation: "NC" },
      { name: "North Dakota", abbreviation: "ND" },
      { name: "Ohio", abbreviation: "OH" },
      { name: "Oklahoma", abbreviation: "OK" },
      { name: "Oregon", abbreviation: "OR" },
      { name: "Pennsylvania", abbreviation: "PA" },
      { name: "Rhode Island", abbreviation: "RI" },
      { name: "South Carolina", abbreviation: "SC" },
      { name: "South Dakota", abbreviation: "SD" },
      { name: "Tennessee", abbreviation: "TN" },
      { name: "Texas", abbreviation: "TX" },
      { name: "Utah", abbreviation: "UT" },
      { name: "Vermont", abbreviation: "VT" },
      { name: "Virginia", abbreviation: "VA" },
      { name: "Washington", abbreviation: "WA" },
      { name: "West Virginia", abbreviation: "WV" },
      { name: "Wisconsin", abbreviation: "WI" },
      { name: "Wyoming", abbreviation: "WY" },
    ];

    return (
      <div>
        <div className="filter-nav-wrapper">
          <div className="filter-wrapper"></div>
          <button
            className="round-button medium-round-button outline-on-hover"
            onClick={() => this.downloadExcel()}
          >
            <SaveToExcelSVG />
            <span>Excel</span>
          </button>
        </div>
        <h3 className="mr-05 ml-05 mt-2 uppercase-text demographicsReportH3">
          <strong>Demographics</strong> Reports
        </h3>
        <p className="demographicsReportMemberCount">
          Member Count: {this.state.data.length}
        </p>
        {this.state.expanded ? (
          <span>
            <h4 className="demographicsReportH4">Personal Information</h4>
            <div
              className="filter-nav-wrapper"
              style={{ backgroundColor: "white" }}
            >
              <div className="filter-wrapper">
                <div className="flex-nowrap align-center">
                  <div
                    className="filter-container"
                    style={{ marginRight: "10px" }}
                  >
                    <label className="outlinedLabelStyle">First Name</label>
                    <InputWithClearButton
                      className="DemographicsReportsInputTextbox"
                      type="text"
                      placeholder="First Name"
                      value={this.state.filters.FirstName}
                      onChange={(e) =>
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            FirstName: e.target.value,
                          },
                        })
                      }
                      onClearValue={() => {
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            FirstName: "",
                          },
                        });
                      }}
                    />
                  </div>
                  <div
                    className="filter-container"
                    style={{ marginRight: "10px" }}
                  >
                    <label className="outlinedLabelStyle">Last Name</label>
                    <InputWithClearButton
                      type="text"
                      placeholder="Last Name"
                      className="DemographicsReportsInputTextbox"
                      value={this.state.filters.LastName}
                      onChange={(e) =>
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            LastName: e.target.value,
                          },
                        })
                      }
                      onClearValue={() => {
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            LastName: "",
                          },
                        });
                      }}
                    />
                  </div>
                  <div
                    className="filter-container"
                    style={{ marginRight: "10px" }}
                  >
                    <label className="outlinedLabelStyle">Chapter</label>

                    <MultiDropDown
                      ref={(el) => (this.chaptersDropDownRef = el)}
                      list={this.props.store.chapterList}
                      borderStyle="1px solid #EAEAEA"
                      multiSelect={true}
                      keyProperty="id"
                      textProperty="state"
                      expandBy="chapters"
                      expandedTextProperty="name"
                      expandedKeyProperty="id"
                      expandedMultiSelect={true}
                      defaultValue={this.state.filters.Chapter}
                      placeholder="Select chapter"
                      onDropDownValueChange={(value) => {
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            Chapter: value,
                          },
                        });
                      }}
                    />
                  </div>
                  <div
                    className="filter-container"
                    style={{ marginRight: "10px" }}
                  >
                    <label className="outlinedLabelStyle">Phone Number</label>
                    <InputWithClearButton
                      type="text"
                      placeholder="Phone Number"
                      className="DemographicsReportsInputTextbox"
                      value={this.state.filters.Phone}
                      onChange={(e) =>
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            Phone: e.target.value,
                          },
                        })
                      }
                      onClearValue={() => {
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            Phone: "",
                          },
                        });
                      }}
                    />
                  </div>
                  <div
                    className="filter-container"
                    style={{ marginRight: "10px" }}
                  >
                    <label className="outlinedLabelStyle">Email</label>
                    <InputWithClearButton
                      type="text"
                      placeholder="Email"
                      className="DemographicsReportsInputTextbox"
                      value={this.state.filters.Email}
                      onChange={(e) =>
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            Email: e.target.value,
                          },
                        })
                      }
                      onClearValue={() => {
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            Email: "",
                          },
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <h4 className="demographicsReportH4">Demographics</h4>
            <div
              className="filter-nav-wrapper"
              style={{ backgroundColor: "white" }}
            >
              <div className="filter-wrapper">
                <div className="flex-nowrap align-center">
                  <div
                    className="filter-container"
                    style={{ marginRight: "10px" }}
                  >
                    <label className="outlinedLabelStyle">Gender</label>
                    <MultiDropDown
                      ref={(el) => (this.genderDropDownRef = el)}
                      list={genderList}
                      multiSelect={true}
                      borderStyle="1px solid #EAEAEA"
                      keyProperty="group"
                      textProperty="group"
                      defaultValue={this.state.filters.Gender}
                      placeholder="Select Gender"
                      onDropDownValueChange={(value) => {
                        this.setState({
                          filters: { ...this.state.filters, Gender: value },
                        });
                      }}
                    />
                  </div>
                  <div
                    className="filter-container"
                    style={{ marginRight: "10px" }}
                  >
                    <label className="outlinedLabelStyle">Race/Ethnicity</label>
                    <MultiDropDown
                      ref={(el) => (this.ethnicityDropDownRef = el)}
                      list={ethnicityList}
                      multiSelect={true}
                      keyProperty="group"
                      textProperty="group"
                      borderStyle="1px solid #EAEAEA"
                      defaultValue={this.state.filters.Ethnicity}
                      placeholder="Select Ethnicity"
                      onDropDownValueChange={(value) =>
                        this.setState({
                          filters: { ...this.state.filters, Ethnicity: value },
                        })
                      }
                    />
                  </div>
                  <div
                    className="filter-container"
                    style={{
                      marginRight: "10px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <label className="outlinedLabelStyle">Date of Birth</label>
                    <div style={{ display: "flex" }}>
                      <input
                        type="date"
                        className="DemographicsReportsInputTextbox"
                        value={this.state.filters.dateOfBirthStart}
                        onChange={(e) =>
                          this.setState({
                            filters: {
                              ...this.state.filters,
                              dateOfBirthStart: e.target.value,
                            },
                          })
                        }
                      />
                      <input
                        type="date"
                        className="DemographicsReportsInputTextbox"
                        value={this.state.filters.dateOfBirthEnd}
                        onChange={(e) =>
                          this.setState({
                            filters: {
                              ...this.state.filters,
                              dateOfBirthEnd: e.target.value,
                            },
                          })
                        }
                      />
                    </div>
                  </div>
                  <div
                    className="filter-container"
                    style={{ marginRight: "10px" }}
                  >
                    <label className="outlinedLabelStyle">Address</label>
                    <InputWithClearButton
                      type="text"
                      placeholder="Address"
                      className="DemographicsReportsInputTextbox"
                      value={this.state.filters.Address}
                      onChange={(e) =>
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            Address: e.target.value,
                          },
                        })
                      }
                      onClearValue={() => {
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            Address: "",
                          },
                        });
                      }}
                    />
                  </div>
                  <div
                    className="filter-container"
                    style={{ marginRight: "10px" }}
                  >
                    <label className="outlinedLabelStyle">City</label>
                    <InputWithClearButton
                      type="text"
                      placeholder="City"
                      className="DemographicsReportsInputTextbox"
                      value={this.state.filters.City}
                      onChange={(e) =>
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            City: e.target.value,
                          },
                        })
                      }
                      onClearValue={() => {
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            City: "",
                          },
                        });
                      }}
                    />
                  </div>
                  <div
                    className="filter-container"
                    style={{ marginRight: "10px" }}
                  >
                    <label className="outlinedLabelStyle">State</label>
                    <MultiDropDown
                      ref={(el) => (this.stateDropDownRef = el)}
                      list={stateList}
                      multiSelect={true}
                      borderStyle="1px solid #EAEAEA"
                      keyProperty="abbreviation"
                      textProperty="abbreviation"
                      defaultValue={this.state.filters.State}
                      placeholder="State"
                      textPropertyRender={(element, textProperty) =>
                        this.stateNameAndAbbrRender(element, textProperty)
                      }
                      onDropDownValueChange={(value) =>
                        this.setState({
                          filters: { ...this.state.filters, State: value },
                        })
                      }
                      search={this.filterList}
                      searchParams={["abbreviation", "name"]}
                    />
                  </div>
                  <div
                    className="filter-container"
                    style={{ marginRight: "10px" }}
                  >
                    <label className="outlinedLabelStyle">Zipcode</label>
                    <InputWithClearButton
                      type="text"
                      className="DemographicsReportsInputTextbox"
                      placeholder="Zipcode"
                      value={this.state.filters.ZipCode}
                      onChange={(e) =>
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            ZipCode: e.target.value,
                          },
                        })
                      }
                      onClearValue={() => {
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            ZipCode: "",
                          },
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <h4 className="demographicsReportH4"> Event Participation</h4>
            <div
              className="filter-nav-wrapper"
              style={{ backgroundColor: "white" }}
            >
              <div className="filter-wrapper">
                <div className="flex-nowrap align-center">
                  <div
                    className="filter-container"
                    style={{ marginRight: "10px" }}
                  >
                    <label className="outlinedLabelStyle">Event Title</label>
                    <MultiDropDown
                      ref={(el) => (this.eventDropDownRef = el)}
                      borderStyle="1px solid #EAEAEA"
                      list={eventList}
                      multiSelect={true}
                      keyProperty="event"
                      textProperty="event"
                      defaultValue={this.state.filters.eventTitle}
                      placeholder="Select Event"
                      onDropDownValueChange={(value) =>
                        this.setState({
                          filters: { ...this.state.filters, eventTitle: value },
                        })
                      }
                    />
                  </div>
                  <div
                    className="filter-container"
                    style={{
                      marginRight: "10px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <label className="outlinedLabelStyle">Date</label>
                    <div style={{ display: "flex" }}>
                      <input
                        type="date"
                        className="DemographicsReportsInputTextbox"
                        value={this.state.filters.eventDateStart}
                        onChange={(e) =>
                          this.setState({
                            filters: {
                              ...this.state.filters,
                              eventDateStart: e.target.value,
                            },
                          })
                        }
                      />
                      <input
                        type="date"
                        className="DemographicsReportsInputTextbox"
                        value={this.state.filters.eventDateEnd}
                        onChange={(e) =>
                          this.setState({
                            filters: {
                              ...this.state.filters,
                              eventDateEnd: e.target.value,
                            },
                          })
                        }
                      />
                    </div>
                  </div>
                  <div
                    className="filter-container"
                    style={{ marginRight: "10px" }}
                  >
                    <label className="outlinedLabelStyle">Disability</label>
                    <MultiDropDown
                      ref={(el) => (this.disabilityDropDownRef = el)}
                      borderStyle="1px solid #EAEAEA"
                      list={disabilityList}
                      multiSelect={true}
                      keyProperty="name"
                      textProperty="name"
                      defaultValue={this.state.filters.disabilityType}
                      placeholder="Select Disability"
                      onDropDownValueChange={(value) =>
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            disabilityType: value,
                          },
                        })
                      }
                    />
                  </div>
                  <div
                    className="filter-container"
                    style={{ marginRight: "10px" }}
                  >
                    <label className="outlinedLabelStyle">
                      Participant Type
                    </label>
                    <MultiDropDown
                      ref={(el) => (this.participantDropDownRef = el)}
                      list={participantList}
                      borderStyle="1px solid #EAEAEA"
                      multiSelect={true}
                      keyProperty="type"
                      textProperty="type"
                      defaultValue={this.state.filters.participantType}
                      placeholder="Select Participant Type"
                      onDropDownValueChange={(value) =>
                        this.setState({
                          filters: {
                            ...this.state.filters,
                            participantType: value,
                          },
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="reportButton" onClick={() => this.runReport()}>
                Run Report
              </div>
              <div
                class="reportButton"
                onClick={() => this.setState({ expanded: false })}
              >
                Hide Filters
              </div>
            </div>
          </span>
        ) : (
          <div
            class="reportButton"
            onClick={() => this.setState({ expanded: true })}
          >
            Show Filters
          </div>
        )}

        {this.state.loading && <Loader />}
        <div>
          <ReactTable
            data={this.state.data}
            columns={this.state.columns}
            defaultPageSize={10}
          />
        </div>
      </div>
    );
  }
}

export default withStore(DemographicReports);



// WEBPACK FOOTER //
// ./src/components/reports/DemographicReports.jsx